import { fetchList, postPayload } from '@bit/knotchinc.web-react-components.utils.fetch-actions';
import { fetchAccount } from 'components/Pages/BlueprintAuth/actions.js';
import { subscriptions, bookmarks, competitors, auth, brands, publishers } from 'api';

export const PROFILE_VIEW_MOUNTED = 'PROFILE_VIEW_MOUNTED';

export const FETCH_USER_COMPETITORS = 'FETCH_USER_COMPETITORS';
export const FETCHED_USER_COMPETITORS = 'FETCHED_USER_COMPETITORS';
export const SET_USER_COMPETITORS_FILTER = 'SET_USER_COMPETITORS_FILTER';

/* ID Specific (any entity type) */
export const REMOVE_USER_COMPETITOR = 'REMOVE_USER_COMPETITOR';
export const REMOVED_USER_COMPETITOR = 'REMOVED_USER_COMPETITOR';
export const CREATE_USER_COMPETITOR = 'CREATE_USER_COMPETITOR';
export const CREATED_USER_COMPETITOR = 'CREATED_USER_COMPETITOR';

export const CREATE_USER_SUBSCRIPTION = 'CREATE_USER_SUBSCRIPTION';
export const CREATED_USER_SUBSCRIPTION = 'CREATED_USER_SUBSCRIPTION';
export const REMOVE_USER_SUBSCRIPTION = 'REMOVE_USER_SUBSCRIPTION';
export const REMOVED_USER_SUBSCRIPTION = 'REMOVED_USER_SUBSCRIPTION';

/* Brand Specific */
export const REMOVE_USER_BRAND_COMPETITOR = 'REMOVE_USER_BRAND_COMPETITOR';
export const REMOVED_USER_BRAND_COMPETITOR = 'REMOVED_USER_BRAND_COMPETITOR';
export const CREATE_USER_BRAND_COMPETITOR = 'CREATE_USER_BRAND_COMPETITOR';
export const CREATED_USER_BRAND_COMPETITOR = 'CREATED_USER_BRAND_COMPETITOR';

export const CREATE_USER_BRAND_SUBSCRIPTION = 'CREATE_USER_BRAND_SUBSCRIPTION';
export const CREATED_USER_BRAND_SUBSCRIPTION = 'CREATED_USER_BRAND_SUBSCRIPTION';
export const REMOVE_USER_BRAND_SUBSCRIPTION = 'REMOVE_USER_BRAND_SUBSCRIPTION';
export const REMOVED_USER_BRAND_SUBSCRIPTION = 'REMOVED_USER_BRAND_SUBSCRIPTION';

/* Publisher Specific */
export const REMOVE_USER_PUBLISHER_COMPETITOR = 'REMOVE_USER_PUBLISHER_COMPETITOR';
export const REMOVED_USER_PUBLISHER_COMPETITOR = 'REMOVED_USER_PUBLISHER_COMPETITOR';
export const CREATE_USER_PUBLISHER_COMPETITOR = 'CREATE_USER_PUBLISHER_COMPETITOR';
export const CREATED_USER_PUBLISHER_COMPETITOR = 'CREATED_USER_PUBLISHER_COMPETITOR';

export const CREATE_USER_PUBLISHER_SUBSCRIPTION = 'CREATE_USER_PUBLISHER_SUBSCRIPTION';
export const CREATED_USER_PUBLISHER_SUBSCRIPTION = 'CREATED_USER_PUBLISHER_SUBSCRIPTION';
export const REMOVE_USER_PUBLISHER_SUBSCRIPTION = 'REMOVE_USER_PUBLISHER_SUBSCRIPTION';
export const REMOVED_USER_PUBLISHER_SUBSCRIPTION = 'REMOVED_USER_PUBLISHER_SUBSCRIPTION';

export const FETCH_USER_SUBSCRIPTIONS = 'FETCH_USER_SUBSCRIPTIONS';
export const FETCHED_USER_SUBSCRIPTIONS = 'FETCHED_USER_SUBSCRIPTIONS';
export const SET_USER_SUBSCRIPTIONS_FILTER = 'SET_USER_SUBSCRIPTIONS_FILTER';

export const CREATE_USER_ENTITY = 'CREATE_USER_ENTITY';
export const CREATED_USER_ENTITY = 'CREATED_USER_ENTITY';

export const CREATE_BOOKMARK = 'CREATE_BOOKMARK';
export const CREATED_BOOKMARK = 'CREATED_BOOKMARK';

export const REMOVE_BOOKMARK = 'REMOVE_BOOKMARK';
export const REMOVED_BOOKMARK = 'REMOVED_BOOKMARK';

export const FETCH_SETTINGS_BRANDS_LIST = 'FETCH_SETTINGS_BRANDS_LIST';
export const FETCHED_SETTINGS_BRANDS_LIST = 'FETCHED_SETTINGS_BRANDS_LIST';
export const SET_SETTINGS_BRANDS_FILTER = 'SET_SETTINGS_BRANDS_FILTER';

export const FETCH_SETTINGS_PUBLISHERS_LIST = 'FETCH_SETTINGS_PUBLISHERS_LIST';
export const FETCHED_SETTINGS_PUBLISHERS_LIST = 'FETCHED_SETTINGS_PUBLISHERS_LIST';
export const SET_SETTINGS_PUBLISHERS_FILTER = 'SET_SETTINGS_PUBLISHERS_FILTER';

export const getCompetitors = (clear) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().Settings.competitorsList,
    fetchingActionType: FETCH_USER_COMPETITORS,
    fetchedActionType: FETCHED_USER_COMPETITORS,
    apiCall: filters => competitors.getList(filters),
  });

/* ID Specific (any entity type) */
export const removeCompetitor = id => dispatch => postPayload({
  dispatch,
  fetchingActionType: REMOVE_USER_COMPETITOR,
  fetchedActionType: REMOVED_USER_COMPETITOR,
  payload: { id },
  fetchedPayload: { id },
  apiCall: () => competitors.remove(id),
});

/* ID Specific (any entity type) */
export const createCompetitor = competitor => dispatch => postPayload({
  dispatch,
  fetchingActionType: CREATE_USER_COMPETITOR,
  fetchedActionType: CREATED_USER_COMPETITOR,
  payload: { id: competitor.public_id },
  fetchedPayload: { competitor },
  apiCall: () => competitors.create(competitor.public_id),
});

/* Brand or Publisher Specific */
export const removeEntityCompetitor = (id, entityType) => dispatch => postPayload({
  dispatch,
  fetchingActionType: entityType === 'brand' ? REMOVE_USER_BRAND_COMPETITOR : REMOVE_USER_PUBLISHER_COMPETITOR,
  fetchedActionType: entityType === 'brand' ? REMOVED_USER_BRAND_COMPETITOR : REMOVED_USER_PUBLISHER_COMPETITOR,
  payload: { id },
  fetchedPayload: { id },
  apiCall: () => competitors.remove(id),
});

/* Brand or Publisher Specific */
export const createEntityCompetitor = (id, entityType) => dispatch => postPayload({
  dispatch,
  fetchingActionType: entityType === 'brand' ? CREATE_USER_BRAND_COMPETITOR : CREATE_USER_PUBLISHER_COMPETITOR,
  fetchedActionType: entityType === 'brand' ? CREATED_USER_BRAND_COMPETITOR : CREATED_USER_PUBLISHER_COMPETITOR,
  payload: { id },
  apiCall: () => competitors.create(id),
});

export const getSubscriptions = (clear) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().Settings.subscriptionsList,
    fetchingActionType: FETCH_USER_SUBSCRIPTIONS,
    fetchedActionType: FETCHED_USER_SUBSCRIPTIONS,
    apiCall: filters => subscriptions.getList(filters),
  });

/* ID Specific (any entity type) */
export const removeSubscription = id => dispatch => postPayload({
  dispatch,
  fetchingActionType: REMOVE_USER_SUBSCRIPTION,
  fetchedActionType: REMOVED_USER_SUBSCRIPTION,
  payload: { id },
  fetchedPayload: { id },
  apiCall: () => subscriptions.remove(id),
});

/* ID Specific (any entity type) */
export const createSubscription = subscription => dispatch =>
  postPayload({
    dispatch,
    fetchingActionType: CREATE_USER_BRAND_SUBSCRIPTION,
    fetchedActionType: CREATED_USER_BRAND_SUBSCRIPTION,
    payload: { id: subscription.public_id },
    fetchedPayload: { subscription },
    apiCall: () => subscriptions.create(subscription.public_id),
  });

/* Brand or Publisher Specific */
export const removeEntitySubscription = (id, entityType) => dispatch => postPayload({
  dispatch,
  fetchingActionType: entityType === 'brand' ? REMOVE_USER_BRAND_SUBSCRIPTION : REMOVE_USER_PUBLISHER_SUBSCRIPTION,
  fetchedActionType: entityType === 'brand' ? REMOVED_USER_BRAND_SUBSCRIPTION : REMOVED_USER_PUBLISHER_SUBSCRIPTION,
  payload: { id },
  fetchedPayload: { id },
  apiCall: () => subscriptions.remove(id),
});

/* Brand or Publisher Specific */
export const createEntitySubscription = (id, entityType) => dispatch =>
  postPayload({
    dispatch,
    fetchingActionType: entityType === 'brand' ? CREATE_USER_BRAND_SUBSCRIPTION : CREATE_USER_PUBLISHER_SUBSCRIPTION,
    fetchedActionType: entityType === 'brand' ? CREATED_USER_BRAND_SUBSCRIPTION : CREATED_USER_PUBLISHER_SUBSCRIPTION,
    payload: { id },
    apiCall: () => subscriptions.create(id),
  });

export const removeBookmark = id => dispatch =>
  postPayload({
    dispatch,
    fetchingActionType: REMOVE_BOOKMARK,
    fetchedActionType: REMOVED_BOOKMARK,
    payload: { id },
    apiCall: () => bookmarks.remove(id),
  });

export const createBookmark = id => dispatch =>
  postPayload({
    dispatch,
    fetchingActionType: CREATE_BOOKMARK,
    fetchedActionType: CREATED_BOOKMARK,
    payload: { id },
    apiCall: () => bookmarks.create(id),
  });

export const selectUserEntity = entity => dispatch => {
  postPayload({
    dispatch,
    fetchingActionType: CREATE_USER_ENTITY,
    fetchedActionType: CREATED_USER_ENTITY,
    payload: { id: entity.public_id },
    fetchedPayload: { entity },
    apiCall: () => auth.setUserEntity(entity.public_id),
  });
  dispatch(fetchAccount('blueprint'));
};

export const fetchSettingsBrands = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().Settings.brandsList,
  fetchingActionType: FETCH_SETTINGS_BRANDS_LIST,
  fetchedActionType: FETCHED_SETTINGS_BRANDS_LIST,
  apiCall: filters => brands.getBrandsList(filters),
});

export const fetchSettingsPublishers = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().Settings.publishersList,
  fetchingActionType: FETCH_SETTINGS_PUBLISHERS_LIST,
  fetchedActionType: FETCHED_SETTINGS_PUBLISHERS_LIST,
  apiCall: filters => publishers.getPublishersList(filters),
});
